/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react/macro'
import colors from '@sportninja/common/constants/appColors'
import { useEffect, useState } from 'react'
import { Flex } from '../Layout'
import Icon from '../Icon'
import { captionXSmall, paragraphSmall, weightRegular } from '../css'

const CopyComponent = ({
  id,
  customText = 'ID',
  alternativeBackground = false,
}) => {
  const [hasCopied, setHasCopied] = useState(false)

  useEffect(() => {
    if (hasCopied) {
      setTimeout(() => {
        setHasCopied(false)
      }, 2000)
    }
  }, [hasCopied])

  return (
    <Flex>
      <Flex alignItems='center' noFlex>
        <Flex
          justifyContent='center'
          alignItems='center'
          css={css`
            /* A flex item will not shrink below its min-content width without
               this, so on a narrow card the chip overflowed its parent instead
               of letting the value below wrap. */
            min-width: 0;
            border-radius: 8px;
            background-color: ${!alternativeBackground
              ? '#1B222B'
              : colors.SECONDARY_300};
            margin-left: 8px;
            padding-left: 8px;
            padding-right: 8px;
            padding-top: ${alternativeBackground ? 8 : 4}px;
            padding-bottom: ${alternativeBackground ? 8 : 4}px;
          `}
        >
          <span
            css={css`
              ${paragraphSmall}
              ${weightRegular}
              color: ${colors.NEUTRAL_100};
            `}
          >
            {customText}
          </span>
          <div
            css={css`
              ${captionXSmall}
              ${weightRegular}
              color: ${colors.WHITE};
              margin-left: 8px;
              margin-right: 8px;
              /* captionXSmall uppercases, which is fine for a caption and wrong
                 for a value: what is rendered here is copied, retyped and read
                 aloud, and a share link's token is CASE-SENSITIVE. The button
                 always wrote the true case, so an uppercased display simply
                 disagreed with the string on the clipboard. Overridden locally
                 — captionXSmall is shared far too widely to change. */
              text-transform: none;
              /* A long unbroken value (a share URL) has no break opportunity, so
                 without this it ran past the card edge and pushed the copy
                 button out of reach on mobile. */
              overflow-wrap: anywhere;
              min-width: 0;
            `}
          >
            {hasCopied ? 'Copied' : id}
          </div>
          <button
            type='button'
            title='Copy UID to clipboard'
            onClick={() => {
              navigator.clipboard.writeText(id)
              setHasCopied(true)
            }}
            css={css`
              height: 100%;
            `}
          >
            <Icon
              faType='far'
              name={hasCopied ? 'clipboard-check' : 'clipboard'}
              color={hasCopied ? colors.DEFAULT_FLAIR : undefined}
              fontSize={16}
            />
          </button>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default CopyComponent
